export const loadingSelector = (state) => state.megaphoneBanner.loading;
export const dataSelector = (state) => state.megaphoneBanner.data;
export const errorsSelector = (state) => state.megaphoneBanner.errors;
